<p-dialog class="acv-modal" [modal]="true" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [visible]="visibility" [draggable]="false" [resizable]="false" [closable]="false" [style]="{ maxWidth: '1230px', width: '100%' }">
  <ng-template pTemplate="header">
    <div class="dialogHeader flex align-items-center justify-content-between wd-100 pl-2">
        <h4 class="font-poppin text-color-grey4 flex gap-2">
          <span class="font-bold">{{title}}</span>
          <span>({{ date | dateTime }})</span>
        </h4>
        <p-button icon="pi pi-times" (onClick)="hide()" styleClass="p-button-text p-button-rounded"></p-button>
    </div>
  </ng-template>

  <ng-template pTemplate="content">
    <div class="leg-detail-container font-poppin">
        <h4 class="font-bold">Pick Up</h4>

        <table class="w-full mt-4">
            <thead>
                <tr>
                    <th class="text-left">Start Date & Time</th>
                    <th class="text-left">End Date & Time</th>
                    <th class="text-left">Actual Start Date & Time</th>
                    <th class="text-left">Actual End Date & Time</th>
                    <th class="text-left">Truck</th>
                    <th class="text-left">Driver</th>
                    <th class="text-left">Trailer</th>
                    <th class="text-left">Status</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>
                        <p class="fs-14 fw-500 text-color-black2 mt-2">
                            {{data?.started_at | dateTime : false }}
                        </p>
                    </td>
                    <td>
                        <p class="fs-14 fw-500 text-color-black2 mt-2">
                            {{data?.completed_at | dateTime : false }}
                        </p>
                    </td>
                    <td>
                        <p class="fs-14 fw-500 text-color-black2 mt-2">
                            {{data?.actual_started_at | dateTime : false }}
                        </p>
                    </td>
                    <td>
                        <p class="fs-14 fw-500 text-color-black2 mt-2">
                            {{data?.actual_completed_at | dateTime : false }}
                        </p>
                    </td>
                    <td>
                        <p class="fs-14 fw-500 text-color-black2 mt-2">
                            {{data?.truck || '-'}}
                        </p>
                    </td>
                    <td>
                        <p class="fs-14 fw-500 text-color-black2 mt-2">
                            {{data?.driver_name || '-'}}
                        </p>
                    </td>
                    <td>
                        <p class="fs-14 fw-500 text-color-black2 mt-2">
                            {{data?.trailer || '-'}}
                        </p>
                    </td>
                    <td>
                        <button style="cursor: default" pButton [attr.status]="data?.status" type="button"
                            class="btn-status p-button-outlined mt-2">
                            {{ data?.status || "-" }}
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
  </ng-template>
</p-dialog>
